// Clerk returns `code: 'session_exists'` when a sign-in or SSO
// call runs against an active session. The message-substring
// fallback covers paths that only populate `message`.
export function isAlreadySignedInError(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const { code, message } = err as { code?: unknown; message?: unknown };
  if (code === 'session_exists') return true;
  return typeof message === 'string' && /already signed in/i.test(message);
}
